module.exports = __webpack_public_path__ + "imgs/arrow-down-black.5bf2c0e4269eebfbfa65079607fe3b5f.svg";